import request from '@/utils/request'

// 查询商品列表
export function listGoods(query) {
  return request({
    url: '/goods/goods/list',
    method: 'get',
    params: query
  })
}

// 查询商品分页
export function pageGoods(data) {
  return request({
    url: '/goods/goods/page',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: data
  })
}

// 查询商品详细
export function getGoods(data) {
  return request({
    url: '/goods/goods/detail',
    method: 'get',
    params: data
  })
}

// 查询商品库存详细
export function getGoodsStock(data) {
  return request({
    url: '/goods/goods/detail/stock',
    method: 'get',
    params: data
  })
}

// 查询商品skuList
export function getGoodsSkuList(data) {
  return request({
    url: '/goods/sku/list',
    method: 'get',
    params: data
  })
}

// 新增商品
export function addGoods(data) {
  return request({
    url: '/goods/goods/add',
    method: 'post',
    data: data
  })
}

// 修改商品
export function updateGoods(data) {
  return request({
    url: '/goods/goods/edit',
    method: 'post',
    data: data
  })
}

export function updateGoodsStock(data) {
  return request({
    url: '/goods/goods/edit/stock',
    method: 'post',
    data: data
  })
}

export function repairGoodsStock(data) {
  return request({
    url: '/goods/goods/stock/repair',
    method: 'post',
    data: data
  })
}

// 删除商品
export function delGoods(data) {
  return request({
    url: '/goods/goods/delete',
    method: 'post',
    data: data
  })
}

export function batchOn(data) {
  return request({
    url: '/goods/goods/batchOn',
    method: 'post',
    data: data
  })
}

export function batchOff(data) {
  return request({
    url: '/goods/goods/batchOff',
    method: 'post',
    data: data
  })
}

export function batchCopy(data) {
  return request({
    url: '/goods/goods/copy',
    method: 'post',
    data: data
  })
}

// 导入商品数据
export function importGoods(data) {
  return request({
    url: '/goods/goods/import',
    method: 'post',
    data: data
  })
}

// 批量修改价格
export function batchUpdatePrice(data) {
  return request({
    url: '/goods/goods/batchUpdatePrice',
    method: 'post',
    data: data
  })
}

// 批量设置赠品
export function batchSetGift(data) {
  return request({
    url: '/goods/goods/batchSetGift',
    method: 'post',
    data: data
  })
}

// 批量设置运费模板
export function batchSetFreightTemplate(data) {
  return request({
    url: '/goods/goods/batchSetFreightTemplate',
    method: 'post',
    data: data
  })
}
